import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * PageErrorBoundary (iter100f)
 *
 * Boundary specifico da avvolgere attorno a pagine "sensibili" (es. Fatture
 * Ricevute per fra.milone). Se il render della pagina crasha, mostra un
 * fallback chiaro con opzioni utente — INVECE di lasciare la schermata blu.
 *
 * Diverso da RootErrorBoundary: qui usiamo Tailwind (l'header/sidebar sono
 * comunque montati) e i pulsanti sono "Ricarica pagina" e "Vai alla home".
 */
export class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[PageErrorBoundary]', this.props.pageName || 'unknown', error, errorInfo);
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      if (url) {
        fetch(`${url}/api/client-errors`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: String(error?.message || error),
            stack: String(error?.stack || ''),
            component_stack: String(errorInfo?.componentStack || ''),
            severity: 'critical',
            location: window.location.href,
            page: this.props.pageName || 'unknown',
            user_agent: navigator.userAgent,
            timestamp: new Date().toISOString(),
          }),
        }).catch(() => {});
      }
    } catch (_) { /* silent */ }
  }

  render() {
    if (!this.state.error) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div className="flex items-center justify-center min-h-[60vh] p-6" data-testid={`page-error-boundary-${this.props.pageName || 'x'}`}>
        <div className="max-w-md w-full bg-white border border-red-200 rounded-lg p-6 shadow-sm">
          <div className="flex items-start gap-3 mb-4">
            <AlertTriangle className="h-6 w-6 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="font-semibold text-slate-900">Errore nel caricamento{this.props.pageName ? ` di ${this.props.pageName}` : ''}</h3>
              <p className="text-sm text-slate-600 mt-1">Qualcosa è andato storto durante il rendering. I tuoi dati sono al sicuro.</p>
            </div>
          </div>
          <details className="mb-4 bg-slate-50 border border-slate-200 rounded-md p-2">
            <summary className="cursor-pointer text-xs text-slate-500">Dettagli tecnici</summary>
            <pre className="mt-2 text-[11px] font-mono whitespace-pre-wrap break-all text-slate-700 max-h-40 overflow-auto">{msg}</pre>
          </details>
          <div className="flex gap-2">
            <button onClick={() => window.location.reload()} className="px-4 py-2 bg-slate-900 text-white rounded-md text-sm font-medium hover:bg-slate-800">Ricarica pagina</button>
            <button onClick={() => window.location.href = '/admin'} className="px-4 py-2 bg-slate-200 text-slate-900 rounded-md text-sm font-medium hover:bg-slate-300">Vai alla home</button>
          </div>
        </div>
      </div>
    );
  }
}

export default PageErrorBoundary;
